/**
 * Stimulus application entrypoint.
 *
 * Loads all controllers in this directory and subdirectories.
 * Controller files must be named *_controller.js.
 *
 * Also adds a Turbo event listener to call `teardown` on controllers before Turbo caches the page,
 * which helps prevent bugs from stale controller state.
 */

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

// Start the Stimulus application
const application = Application.start()

// Load all controller definitions from this directory and subdirectories
const context = require.context("../controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

/**
 * Before Turbo caches the page, call `teardown` on all controllers if defined.
 * This is a workaround for Stimulus controllers that need to clean up state or DOM changes
 * before Turbo replaces the page from cache.
 */
document.addEventListener('turbo:before-cache', () => {
  application.controllers.forEach(controller => {
    // If the controller defines a teardown method, call it
    if (typeof controller.teardown === 'function') {
      controller.teardown()
    }
  })
})
